import { api } from "@/services/api";
import type { IStrategy } from "@pulse-ui/codegen/generated_ts/org_entity";

export const strategyManagementApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // Fetch all strategies
        fetchAllStrategies: builder.query<IStrategy[], void>({
            query: () => "/api/entity/v1/strategies",
            providesTags: ["Strategies"],
        }),

        // Create Strategy
        createStrategy: builder.mutation<Record<string, unknown>, { data: { display_name: string } }>({
            query: ({ data }) => ({
                url: `/api/entity/v1/strategies`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Strategies"],
        }),

        // Delete Strategy
        deleteStrategy: builder.mutation<Record<string, unknown>, { id: string }>({
            query: ({ id }) => ({
                url: `/api/entity/v1/strategies/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Strategies"],
        }),
    }),
});

export const {
    useFetchAllStrategiesQuery,
    useCreateStrategyMutation,
    useDeleteStrategyMutation,
} = strategyManagementApi;
